let interval = null
let domWorks = () => {
 let product_recommendations = document.querySelector('product-recommendations .grid__item')
 if(product_recommendations){
   document.dispatchEvent(new 
CustomEvent("swym:collections-loaded"));
  clearInterval(interval) 
 }
}

interval = setInterval(domWorks, 100)

function swymCallbackFn(swat){
    document.addEventListener("swym:collections-loaded", function(){
      swat.initializeActionButtons(".product_recommendation_slider");
    })
  }
  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);


$('.modal__toggle-open').click(function() {
  $('main').addClass('search_overlay_bg');
  $('body').addClass('overflow-hidden-body');
});
$('.search-modal__close-button').click(function() {
  $('main').removeClass('search_overlay_bg');
  $('body').removeClass('overflow-hidden-body');
});
$('body').on('click', '.search_overlay_bg', function() {
  $('.search-modal__close-button').trigger('click');
})

jQuery(document).on('click', 'button.boost-pfs-search-btn-close-suggestion', function(event) {
  $("main").removeClass("search_overlay_bg");
  $('body').removeClass('overflow-hidden-body');
});


$(window).on('load resize', function() {
  // var swiper = null;

  function initSwiper() {
    if (window.innerWidth <= 1024) {

      var swiper = new Swiper(".custom_function__block", {
        lazy: true,
        autoHeight: false,
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        freeMode: {
          enabled: true,
          sticky: false,
        },
        mousewheel: {
          forceToAxis: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
        },
      });
    } else {

      if (swiper) {
        //         swiper.destroy();
      }
    }
  }

  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper, 200);
  });

  initSwiper();
});



function initSwiper1() {
  swiper1 = new Swiper(".shop_by_age__section .desktop-cont", {
    slidesPerView: "auto",
    centerInsufficientSlides: true,
    spaceBetween: 30,
    loop: false,
    freeMode: {
      enabled: true,
      sticky: true,
    },
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
      600: {
        spaceBetween: 20,
      },

    }
  })
};

function initSwiper2() {
  swiper2 = new Swiper(".social-block-section .desktop-cont", {
    slidesPerView: "auto",
    centerInsufficientSlides: true,
    spaceBetween: 15,
    loop: false,
    freeMode: {
      enabled: true,
      sticky: true,
    },
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
      480: {
        spaceBetween: 15,
      },
      600: {
        spaceBetween: 20,
      },
      1200: {
        spaceBetween: 40,
      },
    },
  });
}

function initSwiperap() {
  swiperap = new Swiper(".article_related-products .products_row", {
    centerInsufficientSlides: false,
    spaceBetween: 15,
    loop: false,
    slidesPerView: 'auto',
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    freeMode: {
      enabled: true,
      sticky: true,
    },
    mousewheel: {
      forceToAxis: true
    },
    breakpoints: {
      1920: {
        spaceBetween: 20,
        slidesPerView: 7
      },
      1440: {
        spaceBetween: 30,
        slidesPerView: 6
      },
      1366: {
        spaceBetween: 30,
        slidesPerView: 5
      },
      1000: {
        spaceBetween: 30,
        slidesPerView: 4
      },
      768: {
        spaceBetween: 30,
        slidesPerView: 3
      },
      575: {
        spaceBetween: 15,
        slidesPerView: 2.5
      },
      320: {
        spaceBetween: 15,
        slidesPerView: 1.5
      },
    },
  });

  swiperap.on('resize load', function (instance) {
  document.querySelector('.article_related-products .products_row').classList.toggle('slider-active', instance.virtualSize > instance.size);
});
}

$(window).on('load resize', function() {
  var swiper1 = null;
  var swiper2 = null;
  var swiperap = null;

  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper1, 200);
  });

  initSwiper1();
  initSwiper2();
  initSwiperap();
});

// 
$(window).on('load resize', function() {
  var swiper3 = null;

  function initSwiper3() {
    if (window.innerWidth <= 1024) {

      swiper3 = new Swiper(".brand-collection .slider-mobile-gutter ", {
        slidesPerView: "auto",
        centerInsufficientSlides: true,
        //         spaceBetween: 20,
        loop: false,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          forceToAxis: true
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    } else {

      if (swiper3) {
        //         swiper3.destroy();
      }
    }
  }
  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper3, 200);
  });

  initSwiper3();
});

$(window).on('load resize', function() {
  var swiper5 = null;

  function initSwiper5() {
    swiper5 = new Swiper(".swiper.slider--on--main", {
      slidesPerView: "auto",
      centerInsufficientSlides: true,
      spaceBetween: 20,
      loop: false,
      freeMode: {
        enabled: true,
        sticky: true,
      },
      mousewheel: {
        forceToAxis: true
      }
    });
  }
  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper5, 200);
  });

  initSwiper5();
});

$(window).on('load resize', function() {
  var swiper6 = null;

  jQuery('.zoom').each(function() {
    if ($(this).find('.zoomImg').length < 1) {
      $(this).zoom();
    }
  });

  if (window.innerWidth <= 993) {
    $('.zoom').trigger('zoom.destroy');
  }

  setTimeout(function() {
    jQuery('.zoom').each(function() {
      var zoomImgwidth = $(this).find('.zoomImg').width();
      var originalImagewidth = $(this).find('.image-zoom').width();
      if (zoomImgwidth < originalImagewidth) {
        $('.zoom').trigger('zoom.destroy');
      }
    });
  }, 500);

  var init = false;
  var swiper6 = Swiper;
  function initSwiper6() {
    let mobile = window.matchMedia("(min-width: 0px) and (max-width: 992px)");
    if (mobile.matches) {
      if (!init) {
      init = true;
      swiper6 = new Swiper(".product_swiper_mobile ", {
        slidesPerView: 1,
        spaceBetween: 50,
        cache: false,
        lazy: true,
        loop: false,
        /*
         pagination: {
           el: ".swiper-pagination",
           type: "progressbar",
         },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        */
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        }

      });
    }
    }
    
      else {
        if (init) {
        swiper6.destroy();
        }
        init = false;
      }
    
  }
  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper6, 200);
  });

  initSwiper6();
});

///get cart and update button status on product page function
function getCart(){
  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => {
    return response.json();
  })
  .then(cart => {
    let upsellProductIdsArr = [];
    $(document).find('.product-form__submit[btn-data-product-id]').each(function(){
      let dataId = $(this).attr('btn-data-product-id');
      upsellProductIdsArr.push(Number(dataId));
    });
    if(cart.item_count > 0 && upsellProductIdsArr?.length > 0){
      upsellProductIdsArr.forEach(function(id) {
        let productObj = cart.items.find(product => product.product_id == id);
        if(productObj){
          $(document).find(`[btn-data-product-id="${productObj.product_id}"]`).prop('disabled', true);
          $(document).find(`[btn-data-product-id="${productObj.product_id}"]`).find('.add-to-cart').css('display', 'none');
          $(document).find(`[btn-data-product-id="${productObj.product_id}"]`).find('.added').css('display', 'inline-block');
          // $(document).find(`.variant_dropdown[data-pairing-section="${productObj.product_id}"]`).addClass('hidden');
          $(document).find(`.variant_dropdown[data-pairing-section="${productObj.product_id}"]`).hide('slow');
        }
      });
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// function getUpsellIds(){
//    $(document).find('.product-form__submit[btn-data-product-id]').each(function(){
//     let dataId = $(this).attr('btn-data-product-id');
//     upsellProductIdsArr.push(Number(dataId));
//   });
// }

$(document).ready(function() {
  ///call cart and update button status on product page js start
  if(window.location.href.includes('/products')){
    // let upsellProductIdsArr = [];
    // $(document).find('.product-form__submit[btn-data-product-id]').each(function(){
    //   let dataId = $(this).attr('btn-data-product-id');
    //   upsellProductIdsArr.push(Number(dataId));
    // });

    getCart();
  }
  ///call cart and update button status on product page js end
  
  $('.view-all-brands').on('click', function(event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr("href")).offset().top
    }, 500)

  });
  $(".first-level_link").click(function() {
    $(".menu_bottom_sec").hide();
  });
  $(".menu-drawer__inner-submenu .second_tier > .custom_drawer_back").click(function() {
    $(".menu_bottom_sec").show();
  });
  $(".header_main_drawer svg.menu__drawer_open").click(function() {});
  $(".header_main_drawer .menu__drawer_close").click(function() {
    $(".menu_bottom_sec").show();
  });
  //    image-text-carousel
  $(".image-slider--on--main").slideUp();
  $(".show_toggle_text").click(function() {
    $(".image-slider--on--main").slideToggle();
  });
  // search input clear
  $(".clear__input-search").click(function() {
    $(".search__input").value = '';
    $(".search__input").val('').empty();
  });

  //   gift textarea empty
  $(".note_drawer_class .drawer__close").click(function() {
    $("#Cart-note").val('').empty();
  });

  window.onload = function() {
    $("#Cart-note").val('').empty();
  }

  $(".cancel-btn").click(function() {
    $("#Cart-note").val('').empty();
  });

  $(".boost-pfs-search-btn-close-suggestion").click(function() {
    $(".boost-pfs-search-box").val('').empty();
  });

  //   product page js
  $(document).on('click', '.variant-select input', function(e) {
    var variantLabel = $(this).val();
    $(this).closest('.product-form__input').find('.variant-label').text(variantLabel);
  });
    /* $(document.body).on('click', '.swym-add-to-wishlist', function (e) {

      $(".added_class").css("display","block");
    });
    $(".slider--on--main").slideUp(); */
  $(".show_toggle").click(function() {
    //     $(this).toggleClass( "active" );
    $(".slider--on--main").addClass('activeSlide');
    //         $(".slider--on--main").slideToggle('slow');
    $(this).hide();
    $(".hide_toggle").show();
  });
  $(".hide_toggle").click(function() {
    $(this).hide();
    $(".show_toggle").show();
    $(".slider--on--main").removeClass('activeSlide');
  })
  $('.accordion').on('click', function() {
    $('.accordion').find('.description_inner').stop().slideUp(600);
    $(this).closest('.accordion').find('.description_inner').stop().slideToggle(600);
    $(this).toggleClass('active');
    $('.accordion').not($(this)).removeClass('active');
  });

  $('.content_tab_switch').on('click', function() {
    this.classList.toggle("active");
  });
  $('.content_tab_switch li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  // Click function
  $('.content_tab_switch li').click(function() {
    $('.content_tab_switch li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    // $('.content__Footer').hide();

    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });

/*
  setTimeout(function() {
    $("#smile-ui-lite-container").css("zIndex", "1");
  }, 3000);
*/

  $('.icon-custom-grid').on('click', function() {
    this.classList.toggle("active");
    $(".listing_button").removeClass('active');
    $(".grid_button").addClass('active');
    $(".grid__item").removeClass('grid__item_1');
    $(".grid__item").addClass('grid__item_2');
    $("#main-collection-product-grid").removeClass('remove-marginMinus');
    $(".boost-pfs-search-panel-product-show .boost-pfs-filter-right .boost-pfs-filter-products").removeClass('remove-marginMinus');

  });

  $('.icon-custom-listing').on('click', function() {
    $(".grid_button").removeClass('active');
    $(".listing_button").addClass('active');
    $(".grid__item").addClass('grid__item_1');
    $(".grid__item").removeClass('grid__item_2');
    $("#main-collection-product-grid").addClass('remove-marginMinus');
    $(".boost-pfs-search-panel-product-show .boost-pfs-filter-right .boost-pfs-filter-products").addClass('remove-marginMinus');
  });

  //   on cart page display table
  $(".listed--main_menu").hover(function() {
    $("cart-items.page-width").css("zIndex", "-1");
  }, function() {
    $("cart-items.page-width").css("zIndex", "1");
  });
  if ($("#SortList li a").attr("href") == window.location.href) {
    $("#SortList li").attr("class", "sort_list active");
  } else {
    $("#SortList li").attr("class", "sort_list");
  }

  $(".brand-title .accordion_title").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".brand-title .panel")
        .slideUp(200);
      $(".brand-title .accordion_title i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".brand-title .accordion_title i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".brand-title .accordion_title").removeClass("active");
      $(this).addClass("active");
      $(".brand-title .panel").slideUp(200);
      $(this)
        .siblings(".brand-title .panel")
        .slideDown(200);
    }
  });

  $(".accordion_block .toggle").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".accordion_block .inner")
        .slideUp(500);
      $(".accordion_block .toggle i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".accordion_block .toggle i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".accordion_block .toggle").removeClass("active");
      $(this).addClass("active");
      $(".accordion_block .inner").slideUp(500);
      $(this)
        .siblings(".accordion_block .inner")
        .slideDown(500);
    }
  });

});

var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
if (isIOS) {
  $(".menu-drawer__utility-links.menu_bottom_sec").css('padding-bottom', '10rem');
  $(".menu-drawer__menu.list-menu.child_list-menu").css('padding-bottom', '13rem');
} else {

}

function detectBrowser() {
  if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
    return 'Opera';
  } else if (navigator.userAgent.indexOf("Chrome") != -1) {
    return 'Chrome';
  } else if (navigator.userAgent.indexOf("Safari") != -1) {
    $(".menu-drawer__utility-links.menu_bottom_sec").css('padding-bottom', '10rem');
  } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    return 'Firefox';
  } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) {
    return 'IE'; //crap
  } else {
    return 'Unknown';
  }
}

//     menu drawer custom js
$(document).ready(function() {
  $('.close_main_menu').on('click', function() {  
    $(".header__icon--summary").attr("aria-expanded", "false");
    $('#menu-drawer').removeClass('menu_open');
    $('body').removeClass('overflow-hidden-mobile');
    $('body').removeClass('overflow-hidden-tablet');
    $('.menu-drawer-container').removeClass('menu-opening');
    setTimeout(function() {
      $('.menu-drawer-container').removeAttr('open');
    }, 500);
  });

  //  Mobile menu drawer overlay 

  $('.menu-drawer-container .header__icon--menu').click(function() {
    $('body').addClass('body_overlay_active');
  });

  $('#menu-drawer .close_main_menu').click(function() {
    setTimeout(function() {
      $('body').removeClass('body_overlay_active');
    }, 200);
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest('#menu-drawer').length && !$(event.target).closest('summary.header__icon').length) {
      $('#menu-drawer .close_main_menu').trigger('click');
    }
  });
  var swiper7 = new Swiper(".announcement_bar_slider", {
    slidesPerView: 1,
    loop: true,
    centeredSlides: true,
    effect: 'slide',
    speed: 1000,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    }
  });
  $(".sub_menu_inr a").on("click", function() {
    localStorage.setItem("activeParent", $(this).closest('.listed--main_menu').attr('id'));
  });
  if (localStorage.getItem("activeParent") != undefined) {
    $('.header__inline-menu').find('.listed--main_menu').find('summary > span.header__active-menu-item').removeClass('header__active-menu-item');
    $('.header__inline-menu .listed--main_menu[id="' + localStorage.getItem("activeParent") + '"] summary > span').addClass('header__active-menu-item');
  }

  var loc = location.href;
  loc.replace(/\/$/, "");
  if (loc.indexOf('/collections/') != -1 || loc.indexOf('/products/') != -1) {} else {
    localStorage.removeItem("activeParent");
    $('.header__inline-menu').find('.listed--main_menu').find('summary > span').removeClass('header__active-menu-item');
  }
});

$(window).on('load resize', function() {
  var swiper8 = null;

  function initSwiper8() {
    if (window.innerWidth <= 768) {

      swiper8 = new Swiper(".product__sub_flex", {
        slidesPerView: 2.5,
        spaceBetween: 20,
        centerInsufficientSlides: true,
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          575: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
        },
      });
    } else {

      if (swiper8) {
        //         swiper8.destroy();
      }
    }
  }

  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper8, 200);
  });

  initSwiper8();
});

$(document).ready(function() {
  //   $('.added_class').html('Item is removed from wishlist ');
  var mediaData = $('.product_swiper_mobile .slider--mobile').attr('media-item');
  if (mediaData == 1) {
    $('.swiper-pagination').hide();
  }

  function initSwiper4() {
    var swiper4 = new Swiper(".sub_collection_de", {
      slidesPerView: 6,
      loop: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 30,

        },
        640: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4.5,
          spaceBetween: 30,
        },
      },
    });
    //      Slider.update();
  }

  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper4, 200);

  });

  initSwiper4();
  //  Slider.update();

});


// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});



jQuery('.form-status.form-status-list.form__message').insertBefore('.contact__button');



// new footer mobile accordion start


  document.addEventListener('DOMContentLoaded', function () {
    var accordionSections = document.querySelectorAll('.accordion-section');

    accordionSections.forEach(function (section) {
      var accordions = section.querySelectorAll('.newfooter_accordion');

      accordions.forEach(function (accordion) {
        var header = accordion.querySelector('.accordion-header');
        var plusButton = header.querySelector('.accordion-plus');
        var minusButton = header.querySelector('.accordion-minus');
        var content = accordion.querySelector('.accordion-content');

        header.addEventListener('click', function () {
          accordion.classList.toggle('active');
          
          if (content.style.display === 'block') {
            content.style.display = 'none';
            plusButton.style.display = 'inline-block';
            minusButton.style.display = 'none';
          } else {
            content.style.display = 'block';
            plusButton.style.display = 'none';
            minusButton.style.display = 'inline-block';
          }
        });
      });
    });
    
    document.querySelectorAll('variant-selects-pair').forEach(pair => {
      const selects = pair.querySelectorAll('select');
      let disableSubmit = false;
      selects.forEach(select => {
          const dataLength = parseInt(select.getAttribute('data-length') || 0, 10);
          if (dataLength > 1) {
              disableSubmit = true;
          }
      });
    
      const parentClass = pair.parentElement; 
      const submitButton = parentClass.querySelector('.product-form__buttons .pairing');
      
      if (submitButton) {
        submitButton.disabled = disableSubmit;
        if (disableSubmit == true) {
          submitButton.classList.add('disabled');
        }
      }
    });

    document.querySelectorAll('variant-selects-pair .select').forEach(selectContainer => {
    const select = selectContainer.querySelector('select');
  
    const dataLength = parseInt(select.getAttribute('data-length') || 0, 10);
    
    if (dataLength <= 1) {
        const svgElement = selectContainer.querySelector('.icon-caret');
        if (svgElement) {
            svgElement.remove();
        }
      select.style.pointerEvents = 'none';
    }
    });
    
  });




// new footer mobile accordion end

// Pulse Effect on megamenu images
document.querySelectorAll(".megamenu-item .location_image").forEach(function(item) {
    item.addEventListener("mouseenter", function(e) {
        this.classList.add('animate__animated', 'animate__pulse');
    });

    item.addEventListener("mouseleave", function(e) {
        this.classList.remove('animate__animated', 'animate__pulse');
    });
});


/* theme.liquid scripts */ 
$(document.body).on('click', '.note_class', function (e) { 
  setTimeout(function(){ 
    $(".note_drawer_class").addClass("is-active");
  }, 300);
  setTimeout(function () {
    $(".note_drawer_class").addClass("is-visible");
  }, 600);
});
var formEmail=$("input[name=email]").val();
$("input[type=hidden][name=hidden_email]").val(formEmail); 
/* get cart */
$.getJSON('/cart', function(cart){
  if(cart.item_count == 0) {
    if(cart.note != ""){
      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        data: {note: ''},
        success: function(result) { 
        },
        error: function(jqxhr, status, exception) {
        }
      }); 
    }
  }
  else {
    if(cart.note == '') {
      $(".message_box").html("<p>Is this a gift? <a class=\"note_class\" href=\"#\" data-drawer-trigger aria-controls=\"drawer-name\" aria-expanded=\"false\">Add a note</a></p>");
    }
    else {
      $(".message_box").html("<p> You've added a gift message! <a class=\"note_class\" href=\"#\" data-drawer-trigger aria-controls=\"drawer-name\" aria-expanded=\"false\">Edit</a></p>");
    }
  }
});
$(document.body).on('click', '.save_class', function (e) {
  var formEmail=$("#Cart-note").val();
  $("input[type=hidden][name=note]").val(formEmail); 
  var data_gift_msg = $("#cart-note").val();
  var gift_msg = $.trim(data_gift_msg);
  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    data: {note: gift_msg},
    success: function(result) { 
      $.getJSON('/cart', function(cart){
        var note = cart.note;
        $('#cart-note').val(note);
        if(note == ''){
          $(".message_box").html("<p>Is this a gift? <a class=\"note_class\" href=\"#\" data-drawer-trigger aria-controls=\"drawer-name\" aria-expanded=\"false\">Add a note</a></p>");
        }
        else{
          $(".message_box").html("<p> You've added a gift message! <a class=\"note_class\" href=\"#\" data-drawer-trigger aria-controls=\"drawer-name\" aria-expanded=\"false\">Edit</a></p>");
        }
        $(".note_drawer_class").removeClass("is-active is-visible");
      });
    },
    error: function(jqxhr, status, exception) {
    }
  });
}); 
$(document.body).on('click', '.cancel-btn', function (e) {
  var formEmail_cancle = $("#cart-note").val();
  $.getJSON('/cart', function(cart){

    var note = cart.note;
    $('#cart-note').val(note);
    if(note == ''){
      $(".message_box").html("<p>Is this a gift? <a class=\"note_class\" href=\"#\" data-drawer-trigger aria-controls=\"drawer-name\" aria-expanded=\"false\">Add a note</a></p>");
    }
    else{
      $(".message_box").html("<p> You've added a gift message! <a class=\"note_class\" href=\"#\" data-drawer-trigger aria-controls=\"drawer-name\" aria-expanded=\"false\">Edit</a></p>");
    }
  });
});
$(document).ready(function() {
  $('.no-links-added').parents('.listed--main_menu').addClass('blank-menu-link');
});
/* End theme.liquid scripts */ 

/* product-recommendations.liquid script */
$(window).on('load resize', function() {
  var pr_swiper = null;

  function initSwiper() {
    pr_swiper = new Swiper(".product_recommendation_slider", {
      slidesPerView: 4,
      centerInsufficientSlides: true,
      spaceBetween: 20,
      loop: false,
      freeMode: {
        enabled: true,
        sticky: true,
      },
      mousewheel: {
        forceToAxis: true
      },
       breakpoints: {
          320: {
            slidesPerView: 1.3,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        }
    });
  }
  var timer;

  window.addEventListener('resize', function() {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(initSwiper, 200);
  });
let interval = null
let domWorks = () => {
  let product_recommendations = document.querySelector('product-recommendations .grid__item');
 if(product_recommendations){
 initSwiper();
   clearInterval(interval);
 }

}

interval = setInterval(domWorks, 100);
});
/* End product-recommendations.liquid script */ 



// Custom Dropdown menu on Policies page

// Final
// document.addEventListener("DOMContentLoaded", function () {
//   const dropdownToggle = document.querySelector(".dropdown-toggle");
//   const dropdownMenu = document.querySelector(".dropdown-menu");
//   const dropdownWrap = document.querySelector(".content_dropdown_menu-wrap");

//   // Initialize with the active menu item (if any)
//   const activeItem = dropdownMenu.querySelector(".dropdown-item.selected");
//   if (activeItem) {
//     dropdownToggle.textContent = activeItem.textContent.trim();
//   }

//   // Toggle the dropdown menu on button click
//   dropdownToggle.addEventListener("click", function (e) {
//     e.stopPropagation(); // Prevent propagation to avoid accidental close
//     dropdownWrap.classList.toggle("active");
//   });

//   // Close the dropdown if clicking outside
//   document.addEventListener("click", function (e) {
//     if (!dropdownWrap.contains(e.target)) {
//       dropdownWrap.classList.remove("active");
//     }
//   });

//   // Update dropdown-toggle text and active state when an item is clicked
//   dropdownMenu.addEventListener("click", function (e) {
//     const clickedItem = e.target.closest(".dropdown-item");
//     if (clickedItem) {
//       // Check if the clicked item is already selected
//       const isAlreadySelected = clickedItem.classList.contains("selected");

//       if (!isAlreadySelected) {
//         // Update the button text only if the item is not already selected
//         dropdownToggle.textContent = clickedItem.textContent.trim();

//         // Remove the "selected" class from all items
//         dropdownMenu.querySelectorAll(".dropdown-item").forEach(item => {
//           item.classList.remove("selected");
//         });

//         // Add the "selected" class to the clicked item
//         clickedItem.classList.add("selected");
//       }

//       // Close the dropdown menu
//       dropdownWrap.classList.remove("active");
//     }
//   });
// });

// changed 1
// document.addEventListener("DOMContentLoaded", function () {
//   const dropdownToggle = document.querySelector(".dropdown-toggle");
//   const dropdownMenu = document.querySelector(".dropdown-menu");
//   const dropdownWrap = document.querySelector(".content_dropdown_menu-wrap");

//   // Initialize with the active menu item (if any)
//   const activeItem = dropdownMenu.querySelector(".dropdown-item.selected");
//   if (activeItem) {
//     dropdownToggle.textContent = activeItem.textContent.trim();
//   }

//   // Prevent blinking: Add a 'prevent-blink' flag
//   let isUpdating = false;

//   // Toggle the dropdown menu on button click
//   dropdownToggle.addEventListener("click", function (e) {
//     e.stopPropagation(); // Prevent event propagation
//     if (!isUpdating) {
//       dropdownWrap.classList.toggle("active");
//     }
//   });

//   // Close the dropdown if clicking outside
//   document.addEventListener("click", function (e) {
//     if (!dropdownWrap.contains(e.target)) {
//       dropdownWrap.classList.remove("active");
//     }
//   });

//   // Update dropdown-toggle text and active state when an item is clicked
//   dropdownMenu.addEventListener("click", function (e) {
//     const clickedItem = e.target.closest(".dropdown-item");
//     if (clickedItem) {
//       // Prevent blinking by flagging the update process
//       isUpdating = true;

//       // Update the button text immediately
//       dropdownToggle.textContent = clickedItem.textContent.trim();

//       // Remove the "selected" class from all items
//       dropdownMenu.querySelectorAll(".dropdown-item").forEach(item => {
//         item.classList.remove("selected");
//       });

//       // Add the "selected" class to the clicked item
//       clickedItem.classList.add("selected");

//       // Close the dropdown menu
//       dropdownWrap.classList.remove("active");

//       // Clear the update flag after a short delay to ensure smooth DOM rendering
//       setTimeout(() => {
//         isUpdating = false;
//       }, 0);
//     }
//   });
// });

// c 2
document.addEventListener("DOMContentLoaded", function () {
  const dropdownToggle = document.querySelector(".dropdown-toggle");
  const dropdownMenu = document.querySelector(".dropdown-menu");
  const dropdownWrap = document.querySelector(".content_dropdown_menu-wrap");

  if(!dropdownMenu) return;
  // Initialize with the active menu item (if any)
  const activeItem = dropdownMenu.querySelector(".dropdown-item.selected");
  if (activeItem) {
    dropdownToggle.textContent = activeItem.textContent.trim();
  }

  // Toggle the dropdown menu on button click
  dropdownToggle.addEventListener("click", function (e) {
    e.stopPropagation(); // Prevent event propagation
    dropdownWrap.classList.toggle("active");
  });

  // Close the dropdown if clicking outside
  document.addEventListener("click", function (e) {
    if (!dropdownWrap.contains(e.target)) {
      dropdownWrap.classList.remove("active");
    }
  });

  // Update dropdown-toggle text and active state when an item is clicked
  dropdownMenu.addEventListener("click", function (e) {
    const clickedItem = e.target.closest(".dropdown-item");

    if (clickedItem) {
      // Avoid redundant updates
      const currentText = dropdownToggle.textContent.trim();
      const newText = clickedItem.textContent.trim();

      if (currentText !== newText) {
        dropdownToggle.textContent = newText;

        // Remove the "selected" class from all items
        dropdownMenu.querySelectorAll(".dropdown-item").forEach(item => {
          item.classList.remove("selected");
        });

        // Add the "selected" class to the clicked item
        clickedItem.classList.add("selected");
      }

      // Close the dropdown menu
      dropdownWrap.classList.remove("active");
    }
  });
});



